import { useConnectedAddress } from '@/domain/wallet/useConnectedAddress'
import { PointsSkeleton } from '@/features/points/components/skeleton/PointsSkeleton'
import { useSparkPoints } from '@/features/points/logic/useSparkPoints'
import { GuestView } from '@/features/points/views/GuestView'
import { PointsView } from '@/features/points/views/PointsView'
import { withSuspense } from '@/ui/utils/withSuspense'

function PointsContainer() {
  const sparkPointsResult = useSparkPoints()
  const { account } = useConnectedAddress({ throwOnNotConnected: false })

  if (!account) {
    return (
      <GuestView
        pointsSeason={sparkPointsResult.pointsSeason}
        previousPointsSeason={sparkPointsResult.previousPointsSeason}
        userChainId={sparkPointsResult.userChainId}
        openConnectWalletModal={sparkPointsResult.openConnectModal}
        showSparkLendBanner={sparkPointsResult.showSparkLendBanner}
      />
    )
  }

  return <PointsView {...sparkPointsResult} account={account} />
}

const PointsContainerWithSuspense = withSuspense(PointsContainer, PointsSkeleton)
export { PointsContainerWithSuspense as PointsContainer }
